<template>
  <div>
    <div class="grid-row">
      <div class="password-form">
        <ChangePasswordForm />
      </div>
    </div>

    <div class="text-left">
      <button
        class="whitebutton-gemnote whitebutton-gemnote--small"
        @click="$store.dispatch('auth/logout')"
      >
        <span>Log out</span>
      </button>
    </div>
  </div>
</template>

<script>
import ChangePasswordForm from './ChangePasswordForm'
export default {
  name: 'LitePaigeSettings',
  components: {
    ChangePasswordForm
  }
}
</script>

<style scope lang="scss">
@import '@/global.scss';

.grid-row {
  display: grid;
  height: 100%;
  margin-bottom: 1rem;

  .password-form {
    grid-column-start: 1;
    grid-column-end: 3;
  }
}

@media (max-width: 1100px) {
  .grid-row {
    grid-template-columns: 1fr 1fr;
    transition: 1s ease-in;
    grid-row-gap: 1em;

    .password-form {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  }
}
</style>
